module.exports = {
  AUDIT_TRIAL_LIST_REQUEST: "AUDIT_TRIAL_REQUEST",
  AUDIT_TRIAL_LIST_SUCCESS: "AUDIT_TRIAL_LIST_SUCCESS",
  AUDIT_TRIAL_LIST_FAIL: "AUDIT_TRIAL_LIST_FAIL",
};
